import React from 'react';
import { HelpCircleIcon, XIcon } from 'lucide-react';
import { TransformCta } from '../TransformCta';
import { faultQuestions, painPoints } from '../../data/problem';
export function Problem() {
  return <section className="bg-panel py-16 sm:py-24" aria-labelledby="problem-title" data-id="element-298" data-mp="2rnlrgwg84h7o">
      <div className="mx-auto max-w-4xl px-5" data-id="element-299" data-mp="2mptwtuo72gzs">
        <h2 id="problem-title" className="text-balance text-center font-display text-[42px] font-extrabold uppercase leading-[0.95] text-white sm:text-6xl" data-id="element-300" data-mp="2mp20ghmrwf8g">
          The problem isn’t always finding the fault.{' '}
          <span className="text-amber" data-id="element-301" data-mp="28p9h57dkt1ai">It’s knowing what to check next.</span>
        </h2>

        <div className="mx-auto mt-10 max-w-2xl space-y-3 text-lg leading-relaxed text-mist" data-id="element-302" data-mp="23qpqito1f1bt">
          <p data-id="element-303" data-mp="6y5zvz96kogz">An HVAC system stops operating correctly. You arrive at the equipment.</p>
          <p className="text-white" data-id="element-304" data-mp="6vtlfw2msw8o">
            The thermostat is calling for operation, but the system isn’t responding as expected. Is the problem
            related to…
          </p>
        </div>

        <ul className="mx-auto mt-6 grid max-w-2xl grid-cols-1 gap-2.5 sm:grid-cols-2" data-id="element-305" data-mp="14deqndzpvwam">
          {faultQuestions.map(q => <li key={q} className="flex items-center gap-3 rounded-xl border border-line bg-ink px-4 py-3 text-[16px] font-semibold text-white" data-id="element-306" data-mp="vax7j8fczjru">
              <HelpCircleIcon className="h-5 w-5 shrink-0 text-volt" aria-hidden="true" data-id="element-307" data-mp="1nzb5xpad0i3x" />
              {q}
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl space-y-3 text-lg leading-relaxed text-mist" data-id="element-308" data-mp="1s04tuinsxwwt">
          <p data-id="element-309" data-mp="1e8q7c1uordl0">
            You begin investigating. But without a structured troubleshooting sequence, the process can quickly become
            fragmented.
          </p>
          <p data-id="element-310" data-mp="26xncd39vzdvt">
            You check one component. Then another. You return to the wiring diagram. You repeat a measurement. You
            discover that an earlier observation was never documented.
          </p>
          <p className="font-semibold text-white" data-id="element-311" data-mp="2ljknofcvevly">
            And suddenly, a relatively straightforward investigation becomes harder to organize.
          </p>
        </div>

        <div className="mx-auto mt-12 max-w-2xl rounded-3xl border-2 border-danger/50 bg-ink p-6 sm:p-8" data-id="element-312" data-mp="2blwtbqj6fq4b">
          <h3 className="font-display text-4xl font-extrabold uppercase text-danger" data-id="element-313" data-mp="26o4qw2kwollv">Sound familiar?</h3>
          <ul className="mt-5 space-y-4" data-id="element-314" data-mp="22mtbsqznrirx">
            {painPoints.map(p => <li key={p} className="flex items-start gap-3 text-[17px] leading-snug text-white" data-id="element-315" data-mp="1xui0yt3dqckl">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-danger" data-id="element-316" data-mp="1svf4hx1gteo8">
                  <XIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-317" data-mp="1nxwu027sure4" />
                </span>
                {p}
              </li>)}
          </ul>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-xl leading-relaxed text-white" data-id="element-318" data-mp="1evxcl8svhlan">
          The solution isn’t another collection of electrical theory.{' '}
          <strong className="text-amber" data-id="element-319" data-mp="3ul4azlf1e6tj">
            It’s a practical system that helps you organize the troubleshooting process from the first observation to
            the final documented conclusion.
          </strong>
        </p>

        <TransformCta label="I’m done guessing — show me the system" data-id="element-320" data-mp="8cuwwlakppiy" />
      </div>
    </section>;
}